import TabsBenefists from './TabsBenefits/TabsBenefists';
import img from '../../assets/img/Illustration/Stars.svg';
import Divider from '../../components/Divider/Divider';
import Button from '../Button/Button';
import { SectionsProps } from '../../types/types';

const Benefits = ({ children, openModal }: SectionsProps) => {
  return (
    <section className='benefits'>
      <Divider />
      <div className='benefits__container'>
        <div className='benefits__info'>
          <h2 className='benefits__title title '>
            Benefits
            <span className='title color'> of ContactPay</span>
          </h2>
          <p className='benefits__text subtitle'>
            Scale Your Business, Reduce Risks and Maximize Profit with Our
            Solutions
          </p>
        </div>
        <div className='benefits__img'>
          <img src={img} alt='Benefits' />
        </div>
        <TabsBenefists className='pays' />
        <Button className='benefits__button' onClick={openModal}>
          {children}
        </Button>
      </div>
    </section>
  );
};
export default Benefits;
